module.exports = __webpack_public_path__ + "img/1-3.140c6d14.svg";